import { DatabaseEnum } from "@Shape-Digital/kudzu-data/lib/types/common";
import { Appointment } from "../AppointmentCardsContainer/types";

interface CheckIsCanLoginParams {
  appointment: Appointment | null;
  role?: DatabaseEnum["center_user_role"];
}

const checkIsCanLogin = ({
  appointment,
  role,
}: CheckIsCanLoginParams): boolean => {
  return !!(
    appointment &&
    role &&
    ["technologist", "super_admin", "regional_admin", "receptionist"].includes(
      role,
    ) &&
    ["confirmed"].includes(appointment.status)
  );
};

export default checkIsCanLogin;
